import type * as React from 'react'

import { type IBaseButtonProps } from './BaseButton'
import { TertiaryButtonStyled } from './styles/TertiaryButtonStyled'

export const TertiaryButton: React.FC<IBaseButtonProps> = TertiaryButtonStyled

TertiaryButton.displayName = 'TertiaryButton'
